import { useMe } from '@/hooks/api/0050_me';
import { Navigate, useParams } from 'react-router-dom';
import { useWorkspace } from '@/hooks/api/0101_workspace';
import { useEffect, useState } from 'react';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useTeam } from '@/hooks/api/0210_team';
import { useCurrentTeam } from '@/providers/TeamProvider';

type Props = { children?: React.ReactNode };

export const RequireTeam = (props: Props) => {
  const { identifier, team_id } = useParams();
  const { data: workspaceData, status: workspaceStatus, error } = useWorkspace(identifier!);
  const { data: teamData, status: teamStatus } = useTeam({ identifier: identifier!, id: Number(team_id!) });
  const { _w_, set_w_, me, setMe, _t_, set_t_ } = useCurrentTeam();
  const [workspaceLoaded, setWorkspaceLoaded] = useState<boolean>(false);
  const [teamLoaded, setTeamLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (workspaceData) {
      set_w_((d) => workspaceData.workspace);
      setMe((d) => workspaceData.user);
      setWorkspaceLoaded(true);
    }

    if (teamData) {
      set_t_((d) => teamData);
      setTeamLoaded(true);
    }
  }, [workspaceData, teamData]);

  if (workspaceStatus == 'error' || teamStatus == 'error') {
    return <Navigate replace to={'/workspaces'} />;
  }

  if (workspaceLoaded && teamLoaded) {
    return <>{props.children}</>;
  }

  return <></>;
};
